import React from "react";
import { Link } from "react-router-dom";

const Packages = () => {
  const appUnlockCards = [
    {
      title: "Clinical-Grade Pregnancy Risk Analysis",
      text: "Download our app to unlock your clinical-grade pregnancy risk analysis, designed by senior doctors using advanced facial-scan AI to decode 23 physical and emotional markers and evaluate your stress levels and risk score in seconds.",
      img: "/clinical-risk-analysis-card.jpeg",
      alt: "Pregnancy risk analysis",
    },
    {
      title: "Exclusive Mom-to-Be Community",
      text: "Join our exclusive mom-to-be community to connect with like-minded mothers walking the exact same phase, where you can share stories, swap milestone experiences, chat, and receive 24/7 expert guidance from Myprega professionals.",
      img: "/Experience2.png",
      alt: "Mom-to-be community",
    },
  ];

  return (
    <div className="packages-section-wrapper">
      <div className="packages-bg-overlay">
         <img src="/PackzdfdfagedB.png" alt="Background Texture" />
      </div>

      <img src="/PackagedL.png" className="floral-bg left" alt="" />
      <img src="/PackagedR.png" className="floral-bg right" alt="" />

      <div className="container py-5 content-relative">
        <section className="app-unlock-section">
          <div className="text-center">
            <h2 className="app-unlock-title">
              Get 24/7 Clarity and Peace of <span className="text-nowrap">Mind—<span className="pink-text">Download</span></span> the App to Unlock:
            </h2>
            <div className="app-download-actions" aria-label="Download Myprega app">
              <a
                href="https://play.google.com/store/apps/details?id=com.myprega.app"
                className="app-download-btn"
                target="_blank"
                rel="noopener noreferrer"
              >
                <i className="bi bi-google-play"></i>
                <span>Download for Android</span>
              </a>
              <a
                href="https://apps.apple.com/app/myprega/id6778800135"
                className="app-download-btn app-download-btn-dark"
                target="_blank"
                rel="noopener noreferrer"
              >
                <i className="bi bi-apple"></i>
                <span>Download for iOS</span>
              </a>
            </div>
          </div>

          <div className="app-unlock-cards">
            {appUnlockCards.map((card) => (
              <article className="app-unlock-card hover-lift" key={card.title}>
                <div className="app-unlock-image">
                  <img src={card.img} alt={card.alt} />
                </div>
                <div className="app-unlock-copy">
                  <h3>{card.title}</h3>
                  <p>{card.text}</p>
                </div>
              </article>
            ))}
          </div>
        </section>

        <div className="text-center mb-5">
          <h2 className="journey-title">
            Everything Your Journey Needs, <br />
            Perfectly <span className="pink-text">Packaged.</span>
          </h2>
          <p className="journey-subtitle mx-auto">
            We’ve replaced the hidden costs and confusing hospital bills with complete
            transparency. Experience the future of pregnancy care risk-free, or dive straight into our
            all-inclusive sanctuary designed for your absolute peace of mind.
          </p>
        </div>

        <div className="row g-4 justify-content-center">
          <div className="col-lg-5 col-md-6">
            <div className="package-card hover-lift">
              <div className="card-image-box">
                <img src="/Packaged1.png" alt="Discovery" className="img-fluid" />
              </div>
              <div className="card-body-content">
                <h3 className="card-package-name">The Discovery Experience</h3>
                <div className="price-tag">
                  <span className="currency">₹</span>0 <small>(Complimentary 7-Day Access)</small>
                </div>
                <ul className="package-features-list">
                  <li><i className="bi bi-check2-circle"></i> 7-Day Platform Access</li>
                  <li><i className="bi bi-check2-circle"></i> Daily Garbhasanskar</li>
                  <li><i className="bi bi-check2-circle"></i> 24/7 Emergency Support</li>
                  <li><i className="bi bi-check2-circle"></i> End-to-End Taste</li>
                </ul>
                <Link to="/elemental-care" className="btn-package btn-solid">
                  Experience It For Free
                </Link>
              </div>
            </div>
          </div>

          <div className="col-lg-5 col-md-6">
            <div className="package-card featured-card hover-lift">
              <div className="card-image-box">
                <img src="/Packaged2.png" alt="Signature Care" className="img-fluid" />
              </div>
              <div className="card-body-content">
                <h3 className="card-package-name">The Signature Care Ecosystem</h3>
                <div className="price-tag">
                  <span className="currency">₹</span>7,222 <small>/ Month</small>
                </div>
                <ul className="package-features-list">
                  <li><i className="bi bi-check2-circle"></i> A Dedicated Circle of 9 Medical Experts</li>
                  <li><i className="bi bi-check2-circle"></i> 44+ Doctor Consultations</li>
                  <li><i className="bi bi-check2-circle"></i> 9 Ultrasound Scans</li>
                  <li><i className="bi bi-check2-circle"></i> 40+ Pathology & Genetic Lab Tests </li>
                  <li><i className="bi bi-check2-circle"></i> AI-Powered Daily Health & Vitals Tracking</li>
                  <li><i className="bi bi-check2-circle"></i> 24/7 Instant Emergency Support</li>
                  <li><i className="bi bi-check2-circle"></i> Personalized Diet & Nutrition Plans</li>
                  <li><i className="bi bi-check2-circle"></i> Live Yoga & Safe Prenatal Fitness Sessions</li>
                  <li><i className="bi bi-check2-circle"></i> 1-on-1 Monthly Mental Health & Lactation Coaching</li>
                  <li><i className="bi bi-check2-circle"></i> Daily Garbhasanskar & Fetal Bonding Rituals</li>
                  <li><i className="bi bi-check2-circle"></i> Monthly Parenting Masterclasses</li>
                  <li><i className="bi bi-check2-circle"></i> Monthly Care Review Sessions</li>
                  <li><i className="bi bi-check2-circle"></i> 24*7 WhatsApp Access to Gynecologist</li>
                  <li><i className="bi bi-check2-circle"></i> Premium Pregnancy Care Kit</li>
                  <li><i className="bi bi-check2-circle"></i> Exclusive Monthly Surprise Hampers</li>
                  <li><i className="bi bi-check2-circle"></i> 100% End-to-End Digital Management</li>
                </ul>
                <Link to="/pricing" className="btn-package btn-solid">
                  Explore The Signature Plan
                </Link>
              </div>
            </div>
          </div>
        </div>

        <p className="text-center mt-5 footer-quote">
          Because every mother deserves the right care at the right time
        </p>
      </div>
    </div>
  );
};

export default Packages;
